import { render } from "./PaymentReceiptCreateFooterActions.vue?vue&type=template&id=21ec4fde&scoped=true"
import script from "./PaymentReceiptCreateFooterActions.vue?vue&type=script&lang=js"
export * from "./PaymentReceiptCreateFooterActions.vue?vue&type=script&lang=js"

import "./PaymentReceiptCreateFooterActions.vue?vue&type=style&index=0&id=21ec4fde&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ec4fde"]])

export default __exports__